<div class="modal-header">
  <div class="title">
      <h2 class="modal-title-prefix">Na koje "vrste dokumenata" želite da postavite novo odgovorno lice?</h2>
  </div>
  <!-- <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span> -->
</div>
<div class="modal-body">

<div *ngFor="let item of rbItems">
  <input 
  type="radio" 
  name="items"
  value="{{item.Name}}"
  (change)="onRadioItemsChange($event)">
  <span>{{item.Value | translate}}</span>
</div>
  <!-- <yt-radio-buttons-group class="test"
  [Items]="rbItems">
</yt-radio-buttons-group> -->
</div>
<div class="modal-footer">
  <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()"><span>Sačuvaj</span></button>
  <!-- <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button> -->